import { BaseLoginService } from 'kuaidong-service'
import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/jumprope-referee-training/Index.vue')
const Order = () => import('../activity/jumprope-referee-training/Order.vue')
const OrderB2B = () => import('../activity/jumprope-referee-training/OrderB2B.vue')
const OrderPaySuccess = () => import('../activity/jumprope-referee-training/OrderPaySuccess.vue')
const EditInvoiceAccount = () => import('../activity/jumprope-referee-training/EditInvoiceAccount.vue')
const EditDeliveryAddress = () => import('../activity/jumprope-referee-training/EditDeliveryAddress.vue')

export const indexRoute: RouteConfig = {
  path: '/jumprope-referee-training-activity',
  name: 'jumprope_referee_training_activity',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '跳绳教练员培训',
    ignoreLogin: true,
  },
}

export const orderRoute: RouteConfig = {
  path: '/jumprope-referee-training-activity-order',
  name: 'jumprope_referee_training_activity_order',
  component: Order,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '订单详情',
    ignoreLogin: true,
  },
}

export const orderB2BRoute: RouteConfig = {
  path: '/jumprope-referee-training-activity-order-b2b',
  name: 'jumprope_referee_training_activity_b2b',
  component: OrderB2B,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '公对公转账',
    ignoreLogin: true,
  },
}

export const orderPaySuccessRoute: RouteConfig = {
  path: '/jumprope-referee-training-activity-order-pay-success',
  name: 'jumprope_referee_training_activity_order_pay_success',
  component: OrderPaySuccess,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '支付成功',
    ignoreLogin: true,
  },
}

export const editInvoiceAccountRoute: RouteConfig = {
  path: '/jumprope-referee-training-activity-edit-invoice-account',
  name: 'jumprope_referee_training_activity_edit_invoice_account',
  component: EditInvoiceAccount,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '开票信息',
    ignoreLogin: true,
  },
}

export const editDeliveryAddressRoute: RouteConfig = {
  path: '/jumprope-referee-training-activity-edit-delivery-address',
  name: 'jumprope_referee_training_activity_edit_delivery_address',
  component: EditDeliveryAddress,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '收货地址',
    ignoreLogin: true,
  },
}

export default [
  indexRoute,
  orderRoute,
  orderB2BRoute,
  orderPaySuccessRoute,
  editInvoiceAccountRoute,
  editDeliveryAddressRoute,
]

export function navigateToJumpropeRefereeTrainingActivity(router: VueRouter) {
  router.push({ name: indexRoute.name })
}

export function navigateToJumpropeRefereeTrainingActivityOrder(router: VueRouter) {
  location.href = BaseLoginService.buildWXWebOauthUrl(orderRoute, null, router)
}

export function navigateToJumpropeRefereeTrainingActivityOrderB2B(router: VueRouter) {
  router.push({ name: orderB2BRoute.name })
}

export function redirectToJumpropeRefereeTrainingActivityOrderPaySuccess(router: VueRouter) {
  router.replace({ name: orderPaySuccessRoute.name })
}

export function navigateToJumpropeRefereeTrainingActivityEditInvoiceAccount(router: VueRouter) {
  router.push({ name: editInvoiceAccountRoute.name })
}

export function navigateToJumpropeRefereeTrainingActivityEditDeliveryAddress(router: VueRouter) {
  router.push({ name: editDeliveryAddressRoute.name })
}
